import {
  Component,
  ElementRef,
  forwardRef,
  inject,
  Input,
  input,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { PayeeRippleDirective } from '../../payee-ripple/payee-ripple.directive';

@Component({
  selector: 'button[payee-button]',
  templateUrl: './payee-button.component.html',
  styleUrls: ['./payee-button.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PayeeButtonComponent),
      multi: true,
    },
  ],
  imports: [MatProgressSpinner, PayeeRippleDirective],
  host: {
    '[class.payee-round-button]': 'isRoundButton()',
    '[class.payee-border-button]': 'isBorderButton()',
    '[attr.color]': 'color()',
    '[attr.width]': 'width()',
    '[attr.height]': 'height()',
  },
})
export class PayeeButtonComponent implements ControlValueAccessor {
  private ref = inject<ElementRef<HTMLButtonElement>>(ElementRef);

  element: HTMLButtonElement;

  @Input() disableRipple = false;
  @Input() loading = false;

  readonly isRoundButton = input(true);
  readonly isBorderButton = input(false);

  readonly color = input<string>();
  readonly width = input<string>();
  readonly height = input<string>();

  constructor() {
    this.element = this.ref.nativeElement;
  }

  // ControlValueAccessor
  onChange = (_obj: any) => {};

  onTouched = () => {};

  writeValue(obj: any): void {
    this.onChange(obj);
  }

  setDisabledState(_isDisabled: boolean): void {}

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  registerOnChange(fn: (obj: any) => void): void {
    this.onChange = fn;
  }
}
